module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/sitebuilder/icons/icon-7.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/sitebuilder/icons/icon-7.png
// module id = 4eBo
// module chunks = 0